/*eslint-disable*/
(function($) {
    Drupal.behaviors.spireLocationEmergencyContact = {

        attach: function(context, settings) {
            // Header phone number
            $(".emergency-contact-header", context).each(function() {
                var default_text = $(".updateable-content", $(this)).html();
                var me = $(this);

                $(".updateable-content", me).html(default_text);
                me.removeClass("hidden");
                $(this).bind("location-update", function(e, data) {
                    if (data.scope == "global") {
                        if (
                            drupalSettings.spireLocation.zipToNumber[
                                data.data.zip
                            ] !== undefined
                        ) {
                            var phone =
                                drupalSettings.spireLocation.zipToNumber[
                                    data.data.zip
                                ].phone;
                            var formatted = phone.replace(
                                /(\d\d\d)(\d\d\d)(\d\d\d\d)/,
                                "$1-$2-$3"
                            );
                            phone =
                                '<a class="emergency-number" href="tel:' +
                                phone +
                                '"><span class="number">' +
                                formatted +
                                "</span></a>";
                            $(".updateable-content", me).html(
                                "For emergencies or customer service, call " +
                                    phone
                            );
                            $(".emergency-number").on('click', function(event){
                                window["dataLayer"].push({
                                    'eventCategory': 'Call Us',
                                    'eventAction': 'Call Customer Service',
                                    'eventLabel': window.location.href,
                                    'eventvalue': '',
                                    'event': 'eventClick'
                                });
                            });
                        } else {
                            $(".updateable-content", me).html(default_text);
                        }
                        spireAttach(me[0]);
                        me.removeClass("hidden");
                    }
                });
            });

            // Footer phone number
            $(".block-locationfooter .column-content", context).each(
                function() {
                    var default_text = $(this).html();
                    var me = $(this);

                    $(this).bind("location-update", function(e, data) {
                        if (data.scope == "global") {
                            if (
                                drupalSettings.spireLocation.zipToNumber[
                                    data.data.zip
                                ] !== undefined
                            ) {
                                var formatted =
                                    '<div class="footer-col">' +
                                    drupalSettings.spireLocation.zipToNumber[
                                        data.data.zip
                                    ].columns[0] +
                                    "</div>";
                                $(me).html(formatted);
                            } else {
                                $(me).html(default_text);
                            }
                            spireAttach(me[0]);
                        }
                    });
                }
            );

            // Footer region
            $(".service-region", context).each(
                function() {
                    var default_text = $(this).html();
                    var me = $(this);

                    $(this).bind("location-update", function(e, data) {
                        if (data.scope == "global") {
                            if (
                                drupalSettings.spireLocation.zipToNumber[
                                    data.data.zip
                                ] !== undefined
                            ) {
                                var formatted =
                                    '<h3>Your service region is<br />' +
                                    drupalSettings.spireLocation.zipToNumber[
                                        data.data.zip
                                    ].region +
                                    "</h3>";
                                $(me).html(formatted);
                            } else {
                                $(me).html(default_text);
                            }
                            spireAttach(me[0]);
                        }
                    });
                }
            );
            
            jQuery(".location-picker").each(function() {
                Location.addPicker($(this));
            });

            $(".global-location-header", context).each(function() {
                if (typeof GlobalLocationHeader !== "undefined") {
                    GlobalLocationHeader.init($(this));
                }
            });
        }
        // End attach function
    };
})(jQuery);
